<template>
	<div class="become-vip-message">
		<Message
			myWidth="615px"
			myHeight="480px"
			bg="#FCFCFC"
			v-if="messageType == 1"
		>
			<template v-slot:content>
				<div class="level-message-wrap">
					<div class="close" @click="closeClick()"></div>
					<div class="level-content-wrap">
						<div class="title">小宝等级说明</div>
						<div class="text1">
							小宝VIP可享受活跃收益积分加成及各项权益，通过升级小宝会员可解锁更多特权。
						</div>
						<div class="text1 text-head">
							小宝等级成长及收益加成规则
						</div>
						<div class="text1 text-circle">
							小宝活跃收益仅对活跃部分的积分进行加成，并非全天积分总收益。
						</div>
						<div class="text1 text-circle">
							小宝VIP达到对应的成长值后提升至对应等级，升级当日即可享受活跃积分加成。
						</div>
						<table class="level-table">
							<tr>
								<td>等级</td>
								<td>成长值区间</td>
								<td>小宝VIP活跃收益加成</td>
							</tr>
							<tr>
								<td>Lv1</td>
								<td>0-100</td>
								<td>0%</td>
							</tr>
							<tr>
								<td>Lv2</td>
								<td>100-500</td>
								<td>5%</td>
							</tr>
							<tr>
								<td>Lv3</td>
								<td>500-1000</td>
								<td>10%</td>
							</tr>
							<tr>
								<td>Lv4</td>
								<td>1000-2000</td>
								<td>15%</td>
							</tr>
							<tr>
								<td>Lv5</td>
								<td>2000+</td>
								<td>20%</td>
							</tr>
						</table>
						<div class="text1 text-head">小宝等级提升</div>
						<div class="text1">
							可通过日常任务或活动获取小宝等级成长值：
						</div>
						<div class="text1 text-circle">
							每日签到：每个自然日可点击小宝会员中心的签到按钮进行签到，完成签到后可获得对应的成长值奖励，每日限1次。
						</div>
						<div class="text1 text-circle">
							设备在线：设备保持全天在线或产生有效贡献即可获得成长值，多台设备均视为统一账户，相应成长值将在次日自动发放。
						</div>
						<div class="text1 text-circle">
							绑定手机：完成绑定手机即可获得100点成长值，仅初次绑定有效。
						</div>
						<div class="text1 text-circle">
							小宝VIP会员成长加速：小宝VIP会员享1.5倍成长值（绑定手机奖励不加倍）。
						</div>
						<div class="text1 text-head">其他说明</div>
						<div class="text1">
							对于通过系统漏洞、弄虚作假、黑客工具、作弊工具等非正常手段参与活动的用户，小宝有权取消其参与活动的资格，冻结或撤销其已获得的权益和奖励；小宝账号、手机号、终端设备或其他合理显示为统一账户的情形均视为同一用户。
						</div>
					</div>
				</div>
			</template>
		</Message>
		<Message
			myWidth="615px"
			myHeight="510px"
			bg="#FCFCFC"
			v-if="messageType == 2"
		>
			<template v-slot:content>
				<div class="rule-message-wrap">
					<div class="close" @click="closeRuleClick()"></div>
					<div class="rule-content-wrap">
						<div class="title">活动规则</div>
						<div class="text1">
							参与签到的用户均需登录节点小宝账户，根据签到天数获得对应奖励。
						</div>
						<div class="text1 text-head">签到周期说明</div>
						<div class="text2">
							同一用户每天仅可签到一次，以7天为一个周期，依次进行签到，每个周期时间结束后，自动开启下个周期。
						</div>
						<div class="text1 text-head">签到奖励</div>
						<div class="text2">
							每日签到可获得不同的“小宝成长值”奖励；
						</div>
						<div class="text2">
							小宝会不定期在签到中加入彩蛋奖励，具体以实际发放为准。
						</div>
						<div class="text1 text-head">签到奖励查看及领取</div>
						<div class="text2">
							基础成长值奖励将自动发放至账户中；
						</div>
						<div class="text2">
							彩蛋奖励将在签到成功弹窗中展示。
						</div>
						<div class="text1 text-head">其他说明</div>
						<div class="text2">
							对于通过系统漏洞、弄虚作假、黑客工具、作弊工具等非正常手段参与活动的用户，小宝有权取消其参与活动的资格，冻结或撤销其已获得的权益和奖励；
						</div>
						<div class="text2">
							小宝账号、手机号、终端设备或其他合理显示为统一账户的情形均视为同一用户。
						</div>
					</div>
				</div>
			</template>
		</Message>
		<Message
			myWidth="369px"
			myHeight="247px"
			bg="#FCFCFC"
			v-if="messageType == 3"
		>
			<template v-slot:content>
				<div class="join-message-wrap">
					<div class="close" @click="closeClick()"></div>
					<div class="title">加入社群</div>
					<div class="text1">节点小宝交流群</div>
					<div
						class="text2 copy-class"
						@click="copyClick()"
						data-clipboard-text="604432396"
					>
						QQ群号：604432396
					</div>
					<div class="text3">
						<a
							target="_blank"
							href="https://qm.qq.com/cgi-bin/qm/qr?k=rKdN7-K0_RyQaD5EelaFI3nlz249NaAv&jump_from=webapi"
							><img
								border="0"
								:src="group"
								alt="节点小宝交流群"
								title="节点小宝交流群"
						/></a>
					</div>
					<div class="confirm-btn" @click="closeClick()">确定</div>
					<Tip v-if="tip" :tip="tip"></Tip>
				</div>
			</template>
		</Message>
		<Message
			myWidth="615px"
			myHeight="439px"
			bg="#FCFCFC"
			v-if="messageType == 4"
		>
			<template v-slot:content>
				<div class="feedback-message-wrap">
					<div class="close" @click="closeClick()"></div>
					<div class="title">意见反馈</div>
					<div class="text-head">反馈类型：</div>
					<div
						class="advice pa"
						:class="{ active: checkType == 1 }"
						@click="checkClick(1)"
					>
						产品建议
					</div>
					<div
						class="advice"
						:class="{ active: checkType == 2 }"
						@click="checkClick(2)"
					>
						产品问题
					</div>
					<div class="text-head text-head2">反馈内容：</div>
					<div class="textarea-wrap">
						<textarea
							class="advice-content"
							:class="{
								'advice-content-active': isTextareaActive,
							}"
							maxlength="160"
							v-model="content"
							@focus="textareaFocus()"
							placeholder="请简单描述您要反馈的问题或建议"
						></textarea>
						<div class="warm-text" v-if="!isGetMonthFeedbackGrowth">
							*温馨提醒：有效反馈奖励5点成长值哦
						</div>
					</div>
					<div v-if="uploadResult.length != 0" class="thumbnail-wrap">
						<div
							v-for="(item, index) in uploadResult"
							:key="index"
							class="thumbnail"
						>
							<img :src="item.file_url" alt="#" />
							<div
								class="delete-btn"
								@click="deleteThumbnailClick(index)"
							></div>
						</div>
					</div>
					<div class="file-wrap">
						<input
							type="file"
							ref="fileInput"
							@change="uploadFileClick()"
						/>
					</div>
					<div class="confirm-btn" @click="feedbackClick()">提交</div>
					<Tip v-if="tip" :tip="tip"></Tip>
					<TipRows :tip="tipArr" v-if="tipArr.length > 0"></TipRows>
				</div>
			</template>
		</Message>
		<Message
			myWidth="615px"
			myHeight="448px"
			bg="#FCFCFC"
			v-if="messageType == 5"
		>
			<template v-slot:content>
				<div class="sign-message-wrap">
					<div class="close" @click="closeClick()"></div>
					<div class="content-wrap">
						<div class="avatar-wrap">
							<img :src="$store.state.user.avatar" alt="#" />
							<div
								:class="{
									'vip-icon': $store.state.user.vip_left > 0,
									'member-icon':
										$store.state.user.vip_left <= 0,
								}"
							>
								{{
									$store.state.user.vip_left <= 0
										? "免费会员"
										: "VIP会员"
								}}
							</div>
						</div>
						<div class="text-wrap">
							<div class="text1">
								已连续签到 <span>{{ times }}</span
								>天
							</div>
							<div
								class="text2"
								v-if="re_sign_in_chance > 0"
								@click="signPastClick()"
							>
								我要补签<span>x{{ re_sign_in_chance }}</span>
							</div>
						</div>
						<div class="sign-wrap">
							<div class="sign-item-wrap">
								<div
									class="sign-item"
									v-for="(item, index) in daily"
									:key="index"
									:class="{
										'sign-item2': item.bg == 'light',
									}"
								>
									<div class="text1">
										+{{ item.growth - item.vip_growth }}
									</div>
									<div class="text2">{{ item.text }}</div>
									<div class="text3">{{ item.dateStr }}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="promotion-rule" @click="showRuleClick()">
						活动规则
					</div>
					<div
						class="sign-btn"
						@click="signClick()"
						v-if="!is_sign_in_today"
					>
						立即签到
					</div>
					<div class="sign-btn sign-btn-disable" v-else>今日已签</div>
					<Tip v-if="tip" :tip="tip"></Tip>

					<div class="sign-success-wrap" v-if="isShowSignSuccess">
						<div class="sign-success-content">
							<div
								class="close"
								@click="closeSignSuccessClick()"
							></div>
							<div class="text1">签到成功</div>
							<div class="text2">
								<div>签到奖励</div>
							</div>
							<div class="sign-reward-wrap">
								<div class="reward1-wrap">
									<div class="reward-icon"></div>
									<div class="growth-roll-wrap">
										<div
											id="roll1"
											style="height: 60px; width: 60px"
										></div>
									</div>
									<div class="reward-text2">成长值</div>
									<div
										class="vip-reward animate__animated animate__fadeOutUp"
										v-if="signResult.vip_growth"
									>
										+{{ signResult.vip_growth }}
									</div>
								</div>
								<div
									class="reward2-wrap"
									v-if="signResult.is_get_resignin_chance"
								>
									<div class="reward-icon"></div>
									<div class="reward-text">+1</div>
									<div class="reward-text2">补签卡</div>
								</div>
							</div>
						</div>
					</div>
					<div class="sign-success-wrap" v-if="isShowSignPastSuccess">
						<div class="sign-success-content">
							<div
								class="close"
								@click="closeSignPastSuccessClick()"
							></div>
							<div class="text1">补签成功</div>
							<div class="text2">
								<div>签到奖励</div>
							</div>
							<div class="sign-reward-wrap">
								<div class="reward1-wrap">
									<div class="reward-icon"></div>
									<div class="growth-roll-wrap">
										<div
											id="roll2"
											style="height: 60px; width: 60px"
										></div>
									</div>
									<div class="reward-text2">成长值</div>
									<div
										class="vip-reward animate__animated animate__fadeOutUp"
										v-if="reSignResult.vip_growth"
									>
										+{{ reSignResult.vip_growth }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Message>

		<Message
			v-if="messageType == 6"
			myHeight="293px"
			myWidth="369px"
			bg="#FCFCFC"
			overflow="visible"
		>
			<template v-slot:content>
				<div class="bind-phone-wrap">
					<div class="close" @click="closeClick()"></div>
					<div class="bind-phone-text1">绑定手机</div>
					<div class="bind-phone-text2">
						为了您的账户安全，请绑定手机号
					</div>
					<div class="input-wrap">
						<div
							:class="{
								'code-btn': true,
								countdown: countdownFlag,
							}"
							@click="sendBindCodeClick"
						>
							{{ codeBtnText }}
						</div>
						<input
							v-model="phone"
							placeholder="手机号"
							class="phone"
							type="number"
							v-on:input="inputFun(1)"
						/>
					</div>
					<div class="input-wrap code-input-wrap">
						<input
							v-model="code"
							placeholder="验证码"
							class="code"
							type="number"
							v-on:input="inputFun(2)"
						/>
					</div>
					<div class="bind-btn" @click="bindClick">绑定</div>
					<Tip v-if="tip" :tip="tip"></Tip>
					<TipRows :tip="tipArr" v-if="tipArr.length > 0"></TipRows>
				</div>
			</template>
		</Message>
	</div>
</template>

<script>
import Clipboard from "clipboard";
import Message from "@/components/MessageTwo.vue";
import Tip from "@/components/Tip.vue";
import TipRows from "@/components/TipRows.vue";
import { mapActions } from "vuex";
import "animate.css";
import * as echarts from "echarts";

export default {
	components: {
		Message,
		Tip,
		TipRows,
	},
	props: {
		messageType: Number,
		isGetMonthFeedbackGrowth: Boolean,
		isGetPhoneGrowth: Boolean,
	},
	data: function () {
		return {
			group: require("../../assets/home/group.png"),
			tip: "",
			checkType: 1, //1产品建议 2产品问题
			content: "",
			isTextareaActive: false,
			isShowRlue: false,
			isShowSignSuccess: false,
			isShowSignPastSuccess: false,
			re_sign_in_chance: 0,
			daily: [],
			times: 0,
			is_sign_in_today: false, //默认今天没有签到，所以可签
			signResult: {
				is_get_resignin_chance: false,
				growth: 0,
				vip_growth: 0,
			},
			reSignResult: {
				growth: 0,
				vip_growth: 0,
			},
			uploadResult: [],
			is_miss_sign_in: false,
			tipArr: [],
			phone: "",
			code: "",
			countdownFlag: false, //true启动倒计时
			codeBtnText: "获取验证码", //获取验证码文本，或者倒计时文本
		};
	},
	methods: {
		...mapActions([
			"userSigninInfo",
			"sendUserlog",
			"userGrowthTake",
			"userFile",
			"feedback",
			"sendLoginBindCode",
			"loginBind",
		]),
		drawChart1: function (data) {
			let chartDom = document.getElementById("roll1");
			let myChart = echarts.init(chartDom);
			let option;
			option = {
				series: [
					{
						type: "gauge",
						startAngle: 90, //起始角度
						endAngle: 450, //终止角度
						center: ["50%", "50%"],
						progress: {
							show: false,
						},
						axisLine: {
							show: false,
						},
						axisTick: {
							show: false,
						},
						splitLine: {
							show: false,
						},
						axisLabel: {
							show: false,
						},
						title: {
							show: false,
						},
						detail: {
							valueAnimation: true,
							formatter: "+{value}",
							fontSize: 24,
							// padding: [0, 0, 0, 0] //上右下左
							offsetCenter: ["0%", "60%"],
							color: "#2360E5",
							fontWeight: "bolder",
						},
						pointer: {
							show: false,
						},
						data: [
							{
								value: data,
							},
						],
					},
				],
			};

			option && myChart.setOption(option);
		},
		drawChart2: function (data) {
			let chartDom = document.getElementById("roll2");
			let myChart = echarts.init(chartDom);
			let option;
			option = {
				series: [
					{
						type: "gauge",
						startAngle: 90, //起始角度
						endAngle: 450, //终止角度
						center: ["50%", "50%"],
						progress: {
							show: false,
						},
						axisLine: {
							show: false,
						},
						axisTick: {
							show: false,
						},
						splitLine: {
							show: false,
						},
						axisLabel: {
							show: false,
						},
						title: {
							show: false,
						},
						detail: {
							valueAnimation: true,
							formatter: "+{value}",
							fontSize: 24,
							offsetCenter: ["0%", "60%"],
							// padding: [0, 0, 0, 0] //上右下左
							color: "#2360E5",
							fontWeight: "bolder",
						},
						pointer: {
							show: false,
						},
						data: [
							{
								value: data,
							},
						],
					},
				],
			};

			option && myChart.setOption(option);
		},

		deleteThumbnailClick: function (index) {
			let _that = this;
			_that.uploadResult.splice(index, 1);
		},
		bindClick: function () {
			let _that = this;
			_that.loginBind([
				_that.phone,
				_that.code,
				_that.$store.state.user.uid,
				function (err, data) {
					if (data.rtn == 0) {
						_that.sendUserlog(["bindPhone_s", ""]);

						//清除登录绑定缓存
						_that.$common.localStorage.removeItem(
							"jdxb-login-bind-flag"
						);
						//放在本地仓库，防止页面刷新丢失号码，如果刷新数据会同步store，home页的user方法会同步数据
						_that.$common.localStorage.setItem(
							"jdxb-phone",
							_that.phone
						);

						_that.$store.state.user.phone = _that.phone;

						if (!_that.isGetPhoneGrowth) {
							_that.userGrowthTake([
								"phone",
								function (err, data) {
									if (data && data.rtn == 0) {
										if (data.data) {
											_that.tipArr.push("绑定成功");
											let text =
												"成长值 +" +
												(data.data.growth -
													data.data.vip_growth);
											_that.tipArr.push(text);
											setTimeout(function () {
												_that.tipArr = [];
												_that.$emit("myUserGrowthInfo");
												_that.closeClick();
											}, 1500);
										}
									}
								},
							]);
						} else {
							_that.tip = "绑定成功";
							setTimeout(function () {
								_that.tip = "";

								_that.closeClick();
							}, 1500);
						}
					} else {
						_that.sendUserlog([
							"bindPhone_f",
							JSON.stringify(data),
						]);
						_that.tip = "绑定失败";
						setTimeout(function () {
							_that.tip = "";

							_that.closeClick();
						}, 1500);
					}
				},
			]);
		},
		countdown: function (leftTime) {
			let _that = this;
			//倒计时
			let time = setTimeout(function () {
				if (leftTime > 1) {
					--leftTime;
					_that.countdownFlag = true;
					_that.codeBtnText = leftTime + "秒后可重发";
					_that.countdown(leftTime);
				} else {
					_that.countdownFlag = false;
					_that.codeBtnText = "获取验证码";
					_that.$common.localStorage.removeItem("jdxb-endTime");
					clearTimeout(time);
				}
			}, 1000);
		},
		sendBindCodeClick: function () {
			let _that = this;

			if (_that.phone == "" || _that.phone.length != 11) {
				_that.tip = "请输入正确的手机号";
				setTimeout(function () {
					_that.tip = "";
				}, 1500);
				//发送验证码前校验手机号
				return;
			} else {
				//倒计时
				if (_that.codeBtnText.indexOf("获取验证码") != -1) {
					let endTime = localStorage.getItem("jdxb-endTime");
					let currentTime = new Date().getTime();

					if (endTime > currentTime) {
						return;
					} else {
						_that.sendLoginBindCode([
							_that.phone,
							_that.$store.state.user.uid,
							function (err, data) {
								if (data.rtn == 0) {
									_that.tip = "发送成功";
									setTimeout(function () {
										_that.tip = "";
									}, 1500);
								} else {
									if (data.rtn == 10217) {
										_that.tip = "该手机号已被其他账户绑定";
									} else {
										_that.tip = "发送失败";
									}
									setTimeout(function () {
										_that.tip = "";
										_that.closeClick();
									}, 1500);
								}
							},
						]);
					}
					//开始倒计时
					_that.$common.localStorage.setItem(
						"jdxb-endTime",
						new Date().getTime() + 60000
					);
					_that.countdown(60);
				}
			}
		},
		inputFun: function (flag) {
			let _that = this;
			if (flag == 1) {
				if (_that.phone.length > 11) {
					_that.phone = _that.phone.slice(0, 11);
				}
			} else {
				if (_that.code.length > 6) {
					_that.code = _that.code.slice(0, 6);
				}
			}
		},
		uploadFileClick: function () {
			let _that = this;
			let file = _that.$refs.fileInput.files[0];
			let formData = new window.FormData();
			formData.append("file", file);

			_that.userFile([
				formData,
				function (err, data) {
					if (data && data.rtn == 0) {
						if (data.data) {
							let fileItem = {
								file_id: data.data.file_id,
								file_url: data.data.file_url,
							};
							_that.uploadResult.push(fileItem);

							_that.tip = "上传成功";
							setTimeout(function () {
								_that.tip = "";
							}, 1500);
						}
					}
				},
			]);
		},
		signPastClick: function () {
			let _that = this;
			if (!_that.is_miss_sign_in) {
				_that.tip = "暂无漏签，无需补签";
				setTimeout(function () {
					_that.tip = "";
				}, 1500);
			} else {
				_that.userGrowthTake([
					"resignin",
					function (err, data) {
						if (data && data.rtn == 0) {
							if (data.data) {
								_that.reSignResult = data.data;
								_that.isShowSignPastSuccess = true;

								setTimeout(function () {
									_that.drawChart2(_that.reSignResult.growth);
								}, 100);
								_that.myUserSigninInfo();

								_that.$emit("myUserGrowthInfo");
							}
						}
					},
				]);
			}
		},
		closeSignPastSuccessClick: function () {
			let _that = this;
			_that.isShowSignPastSuccess = false;
		},
		closeSignSuccessClick: function () {
			let _that = this;
			_that.isShowSignSuccess = false;
		},
		signClick: function () {
			let _that = this;

			_that.userGrowthTake([
				"signin",
				function (err, data) {
					if (data && data.rtn == 0) {
						if (data.data) {
							_that.signResult = data.data;

							_that.isShowSignSuccess = true;

							setTimeout(function () {
								_that.drawChart1(_that.signResult.growth);
							}, 100);

							_that.myUserSigninInfo();

							_that.$emit("myUserGrowthInfo");
							_that.$emit("myUserSigninInfo");
						}
					}
				},
			]);
		},
		showRuleClick: function () {
			let _that = this;
			_that.$emit("showRuleClick");
		},
		closeRuleClick: function () {
			let _that = this;
			_that.$emit("closeRuleClick");
		},
		feedbackClick: function () {
			let _that = this;
			if (_that.content) {
				let img_ids = [];
				for (
					let index = 0;
					index < _that.uploadResult.length;
					index++
				) {
					img_ids.push(_that.uploadResult[index].file_id);
				}
				_that.feedback([
					_that.content,
					img_ids,
					_that.checkType,
					function (err, data) {
						if (data && data.rtn == 0) {
							if (!_that.isGetMonthFeedbackGrowth) {
								_that.userGrowthTake([
									"feedback",
									function (err, data) {
										if (data && data.rtn == 0) {
											if (data.data) {
												_that.tipArr.push("提交成功");
												let text =
													"成长值 +" +
													(data.data.growth -
														data.data.vip_growth);
												_that.tipArr.push(text);
												setTimeout(function () {
													_that.tipArr = [];
													_that.$emit(
														"myUserGrowthInfo"
													);
													_that.closeClick();
												}, 1500);
											}
										}
									},
								]);
							} else {
								_that.tip = "提交成功";
								setTimeout(function () {
									_that.tip = "";

									_that.closeClick();
								}, 1500);
							}
						}
					},
				]);
			}
		},
		textareaFocus: function () {
			let _that = this;
			_that.isTextareaActive = true;
		},
		checkClick: function (data) {
			let _that = this;
			_that.checkType = data;
		},
		closeClick: function () {
			let _that = this;
			_that.$emit("closeMessageClick");
		},
		copyClick: function () {
			let _that = this;
			let clipboard = new Clipboard(".copy-class");
			clipboard.on("success", (e) => {
				clipboard.destroy();
				_that.tip = "复制成功";
				setTimeout(function () {
					_that.tip = "";
				}, 1500);
			});
			clipboard.on("error", (e) => {
				clipboard.destroy();
				_that.tip = "复制失败";

				setTimeout(function () {
					_that.tip = "";
				}, 1500);
			});
		},
		myUserSigninInfo: function () {
			let _that = this;

			_that.userSigninInfo([
				function (err, data) {
					if (data && data.rtn == 0) {
						if (data.data) {
							if (data.data.re_sign_in_chance != undefined) {
								_that.re_sign_in_chance =
									data.data.re_sign_in_chance;
							}
							if (data.data.is_miss_sign_in != undefined) {
								_that.is_miss_sign_in =
									data.data.is_miss_sign_in;
							}
							if (data.data.daily) {
								for (
									let index = data.data.daily.length - 1;
									index > -1;
									index--
								) {
									let item = data.data.daily[index];
									let dateStr = item.date;
									let dateStr2 = "";
									if (dateStr.charAt(5) == "0") {
										dateStr2 = dateStr.substring(6);
									} else {
										dateStr2 = dateStr.substring(5);
									}
									item.dateStr = dateStr2.replace("-", ".");

									let today = new Date().toLocaleDateString();
									let someday = new Date(
										dateStr
									).toLocaleDateString();

									if (someday == today) {
										item.dateStr = "今天";
										if (item.is_sign_in) {
											_that.is_sign_in_today = true;
											item.text = "成长值";
											item.bg = "light";
										} else {
											_that.is_sign_in_today = false;
											item.text = "成长值";
											item.bg = "dark";
										}
									} else if (someday > today) {
										item.text = "成长值";
										item.bg = "dark";
									} else {
										if (item.is_sign_in) {
											item.text = "成长值";
											item.bg = "light";
										} else {
											item.text = "未签到";
											item.bg = "dark";
										}
									}
								}
								_that.daily = data.data.daily;

								let todayIndex = 0;
								let times = 0;
								for (
									let index = data.data.daily.length - 1;
									index > -1;
									index--
								) {
									let item = data.data.daily[index];
									let dateStr = item.date;

									let today = new Date().toLocaleDateString();
									let someday = new Date(
										dateStr
									).toLocaleDateString();

									if (someday == today) {
										todayIndex = index;
										if (item.is_sign_in) {
											++times;
										}
									} else if (someday < today) {
										if (--todayIndex == index) {
											if (item.is_sign_in) {
												++times;
											} else {
												break;
											}
										}
									}
								}
								_that.times = times;
							}
						}
					}
				},
			]);
		},
	},
	mounted() {
		let _that = this;

		if (_that.messageType == 5) {
			_that.myUserSigninInfo();
		}
	},
};
</script>

<style scoped lang="less">
.become-vip-message {
	font-size: 12px;
	color: #666666;

	.bg {
		background-position: center;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
	.close {
		position: absolute;
		z-index: 1;
		top: 10px;
		right: 10px;
		width: 20px;
		height: 20px;
		padding: 1px;
		.bg();
		background-image: url("../../assets/common/close4.svg");
		cursor: pointer;
	}

	.level-message-wrap {
		position: relative;
		padding: 0 48px;
		padding-top: 1px;
		text-align: center;

		.level-content-wrap {
			text-align: center;
			margin-top: 31px;
			height: 428px;
			-ms-scroll-chaining: chained;
			-ms-content-zooming: zoom;
			-ms-scroll-rails: none;
			-ms-content-zoom-limit-min: 100%;
			-ms-content-zoom-limit-max: 500%;
			-ms-scroll-snap-type: proximity;
			-ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
			-ms-overflow-style: none;
			scrollbar-width: none;
			overflow: auto;

			.title {
				display: inline-block;
				margin-bottom: 40px;
				text-align: center;
				padding: 0 30px;
				font-weight: 700;
				font-size: 17px;
				color: #1a1a1a;
				.bg();
				background-image: url("../../assets/becomevip/g1.svg");
			}
			.text1 {
				text-align: left;
				line-height: 22px;
			}
			.text-head {
				margin-top: 20px;
				margin-bottom: 7px;
				font-weight: 700;
			}
			.text-circle {
				position: relative;
				padding-left: 20px;
			}
			.text-circle::before {
				position: absolute;
				left: 7px;
				top: 7px;
				content: "";
				width: 7px;
				height: 7px;
				border-radius: 50%;
				background-color: #1f5de3;
			}
			.level-table {
				margin-left: 20px;
				margin-top: 14px;
				border: 1px solid #cccccc;
				border-right: none;
				border-bottom: none;
				border-spacing: 0;

				tr td {
					width: 126px;
					line-height: 36px;
					border-right: 1px solid #cccccc;
					border-bottom: 1px solid #cccccc;
				}
				tr:first-child {
					background-color: #e6e6e6;
					color: #1a1a1a;
				}
				tr td:first-child {
					color: #1a1a1a;
				}
			}
		}

		.level-content-wrap::-webkit-scrollbar {
			display: none;
		}
	}

	.rule-message-wrap {
		position: relative;
		padding: 0 48px;
		padding-top: 1px;

		.rule-content-wrap {
			margin-top: 26px;
			.title {
				margin-bottom: 40px;
				text-align: center;
				color: #d78a0a;
				font-size: 17px;
				font-weight: 700;
			}
			.text1 {
				font-weight: 700;
			}
			.text-head {
				margin-top: 20px;
				margin-bottom: 7px;
				padding-left: 10px;
				color: #ffa000;
				.bg();
				background-image: url("../../assets/userinfo/a1.svg");
				background-size: 3px 10px;
				background-position: left center;
			}
			.text2 {
				line-height: 22px;
			}
		}
	}

	.join-message-wrap {
		text-align: center;
		position: relative;
		padding-top: 1px;

		.title {
			margin-top: 13px;
			font-size: 17px;
			font-weight: 700;
			color: #1a1a1a;
		}
		.text1 {
			margin-top: 32px;
			font-weight: 700;
			font-size: 14px;
		}
		.text2 {
			position: relative;
			display: inline-block;
			margin-top: 9px;
			width: 280px;
			height: 41px;
			line-height: 41px;
			font-size: 14px;
			background-color: rgba(31, 93, 227, 0.04);
			border-radius: 20px;
		}
		.text2::after {
			content: "";
			position: absolute;
			right: 38px;
			top: 10px;
			width: 20px;
			height: 20px;
			.bg();
			background-image: url("../../assets/userinfo/a2.svg");
			cursor: pointer;
		}
		.text3 {
			margin-top: 7px;
			height: 20px;
		}
		.confirm-btn {
			margin: 0 auto;
			margin-top: 20px;
			width: 156px;
			height: 41px;
			line-height: 41px;
			border-radius: 102px;
			font-size: 14px;
			color: #ffffff;
			font-weight: 700;
			background-color: #1f5de3;
			cursor: pointer;
		}
		.confirm-btn:hover {
			opacity: 0.9;
		}
	}

	.feedback-message-wrap {
		position: relative;
		padding-top: 1px;
		padding-left: 48px;
		padding-right: 48px;

		.title {
			margin-top: 13px;
			text-align: center;
			font-size: 17px;
			font-weight: 700;
			color: #1a1a1a;
		}
		.text-head {
			margin-top: 30px;
			font-size: 14px;
			font-weight: 700;
			color: #1a1a1a;
		}
		.advice {
			position: relative;
			margin-top: 10px;
			display: inline-block;
			padding-left: 22px;
			height: 22px;
			line-height: 22px;
			font-size: 14px;
			cursor: pointer;
		}
		.advice::before {
			content: "";
			position: absolute;
			.bg();
			left: 0;
			top: 3px;
			width: 14px;
			height: 14px;
			background-image: url("../../assets/userinfo/a3.svg");
		}
		.pa {
			margin-left: 20px;
			margin-right: 20px;
		}
		.active::before {
			background-image: url("../../assets/userinfo/a4.svg");
		}
		.text-head2 {
			margin-top: 20px;
		}

		.textarea-wrap {
			margin-top: 10px;
			position: relative;
			width: 100%;
			height: 125px;
			.advice-content {
				padding: 20px;
				padding-top: 18px;
				padding-bottom: 30px;
				height: 100%;
				box-sizing: border-box;
				background-color: #f2f5fd;
				width: 100%;
				resize: none;
				border-radius: 3px;
				color: #666666;
				line-height: 20px;
				overflow: hidden;
				border: 1px solid #f2f5fd;
				font-size: 14px;
			}
			.advice-content-active {
				background-color: #fcfdff;
				border: 1px solid #ebeef5;
			}
			.warm-text {
				text-align: right;
				padding-right: 13px;
				position: absolute;
				line-height: 27px;
				height: 27px;
				width: 100%;
				right: 0;
				bottom: 0;
				color: #f57c4e;
				background-color: #f2f5fd;
				box-sizing: border-box;
			}

			textarea::-webkit-input-placeholder {
				/* WebKit, Blink, Edge */
				color: #999999;
				font-size: 14px;
			}

			:-moz-placeholder {
				/* Mozilla Firefox 4 to 18 */
				color: #999999;
				font-size: 14px;
			}

			::-moz-placeholder {
				/* Mozilla Firefox 19+ */
				color: #999999;
				font-size: 14px;
			}

			input:-ms-input-placeholder {
				/* Internet Explorer 10-11 */
				color: #999999;
				font-size: 14px;
			}

			input::-ms-input-placeholder {
				/* Microsoft Edge */
				color: #999999;
				font-size: 14px;
			}
		}
		.thumbnail-wrap {
			margin-top: 10px;
			display: inline-block;
			vertical-align: top;
			.thumbnail {
				position: relative;
				display: inline-block;
				margin-right: 10px;
				vertical-align: top;
				width: 58px;
				height: 41px;
				box-sizing: border-box;
				border: 1px solid #e6e6e6;

				img {
					width: 100%;
					height: 100%;
				}

				.delete-btn {
					position: absolute;
					right: -8px;
					top: -8px;
					width: 17px;
					height: 17px;
					.bg();
					background-image: url("../../assets/userinfo/c10.svg");
					cursor: pointer;
				}
			}
		}
		.file-wrap {
			margin-top: 10px;
			display: inline-block;
			vertical-align: top;
			position: relative;
			padding-left: 38px;
			width: 58px;
			height: 41px;
			background-color: #e6e6e6;
			box-sizing: border-box;
			border-radius: 2px;
			overflow: hidden;
			font-size: 14px;

			input {
				position: absolute;
				top: 0;
				right: 0;
				height: 100%;
				cursor: pointer;
				opacity: 0;
				background-color: transparent;
				color: transparent;
			}
		}
		.file-wrap::before {
			content: "";
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 20px;
			height: 20px;
			.bg();
			background-image: url("../../assets/userinfo/a5.svg");
		}

		.confirm-btn {
			margin: 0 auto;
			margin-top: 30px;
			width: 112px;
			height: 36px;
			line-height: 36px;
			text-align: center;
			border-radius: 58px;
			background-color: #1f5de3;
			color: #ffffff;
			font-size: 14px;
			font-weight: 700;
			cursor: pointer;
		}
	}

	.sign-message-wrap {
		position: relative;
		padding-top: 1px;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		.bg();
		background-image: url("../../assets/userinfo/b3.png");

		.content-wrap {
			position: absolute;
			padding-top: 20px;
			top: 115px;
			left: 31px;
			z-index: 1;
			background-color: #ffffff;
			width: 554px;
			height: 258px;
			box-sizing: border-box;
			border-radius: 3px;
			border: 1px solid #ffe28f;

			.avatar-wrap {
				position: relative;
				display: inline-block;
				margin-left: 20px;
				width: 75px;
				height: 75px;
				border-radius: 50%;
				background-image: url("../../assets/becomevip/vip10.svg");
				.bg();
				padding: 2px;
				box-sizing: border-box;

				img {
					width: 71px;
					height: 71px;
					border-radius: 50%;
				}
				.member-icon,
				.vip-icon {
					position: absolute;
					padding-left: 30px;
					padding-top: 1px;
					left: -2px;
					top: 59px;
					width: 82px;
					height: 28px;
					line-height: 28px;
					box-sizing: border-box;
					text-align: left;
					.bg();
					background-image: url("../../assets/userinfo/userinfo6.png");
				}
				.member-icon {
					padding-left: 28px;
				}
				.vip-icon {
					background-image: url("../../assets/userinfo/userinfo7.png");
				}
			}

			.text-wrap {
				margin-top: 15px;
				display: inline-block;
				vertical-align: top;
				text-align: left;
				margin-left: 14px;
				.text1 {
					color: #9f9371;
					font-size: 14px;
					span {
						display: inline-block;
						margin-left: 3px;
						margin-right: 3px;
						color: #7b5b19;
						font-weight: 700;
						font-size: 20px;
					}
				}
				.text2 {
					margin-top: 7px;
					padding-left: 27px;
					color: #9f9371;
					font-size: 12px;
					background-image: url("../../assets/userinfo/a6.svg");
					background-position: left center;
					background-repeat: no-repeat;
					background-size: 20px 20px;
					cursor: pointer;

					span {
						display: inline-block;
						text-align: center;
						width: 40px;
						letter-spacing: 2px;
						color: #936e0d;
						font-weight: 700;
						height: 17px;
						line-height: 17px;
						border-radius: 31px;
						background-image: linear-gradient(
							to right,
							#fff8e0,
							#fdebad
						);
						border: 1px solid #fff3ce;
					}
				}
			}
			.sign-wrap {
				margin-top: 25px;
				text-align: center;

				.sign-item {
					padding-top: 1px;
					display: inline-block;
					margin-left: 5px;
					margin-right: 5px;
					width: 65px;
					height: 85px;
					box-sizing: border-box;
					.bg();
					background-image: url("../../assets/userinfo/c3.png");
					text-align: center;
					vertical-align: top;

					.text1 {
						margin-top: 42px;
						font-size: 17px;
						color: #bbaa7c;
						font-weight: 700;
					}
					.text2 {
						margin-top: -2px;
						font-size: 12px;
						color: #bbaa7c;
					}
					.text3 {
						color: #9f9371;
						font-size: 12px;
						margin-top: 14px;
					}
				}
				.sign-item2 {
					background-image: url("../../assets/userinfo/c1.svg");
				}
			}
		}
		.content-wrap::before {
			position: absolute;
			z-index: 1;
			top: 20px;
			right: 20px;
			content: "";
			width: 215px;
			height: 83px;
			.bg();
			background-image: url("../../assets/userinfo/b5.svg");
		}
		.content-wrap::after {
			position: absolute;
			top: 14px;
			right: 7px;
			content: "";
			width: 240px;
			height: 94px;
			.bg();
			background-image: url("../../assets/userinfo/b6.png");
		}

		.promotion-rule {
			margin-top: 383px;
			margin-left: 46px;
			padding-left: 18px;
			color: #7b5b19;
			font-size: 12px;
			background-size: 14px 14px;
			background-position: left center;
			background-image: url("../../assets/userinfo/b4.svg");
			background-repeat: no-repeat;
			cursor: pointer;
		}
		.sign-btn {
			position: absolute;
			top: 387px;
			left: 230px;
			text-align: center;
			width: 156px;
			height: 41px;
			font-size: 14px;
			line-height: 41px;
			color: #ffffff;
			font-weight: 700;
			border-radius: 102px;
			background-image: linear-gradient(to right, #f8612b, #f8564a);
			cursor: pointer;
		}
		.sign-btn-disable {
			font-weight: 700;
			color: #7c2c1a;
			background-image: linear-gradient(to right, #fb9a78, #fb948a);
		}

		.sign-success-wrap {
			position: absolute;
			padding-top: 1px;
			width: 615px;
			height: 448px;
			top: 0;
			left: 0;
			z-index: 5;
			background-color: rgba(81, 81, 81, 0.35);
			box-sizing: border-box;

			.sign-success-content {
				position: relative;
				margin: 0 auto;
				margin-top: 66px;
				padding-top: 1px;
				width: 350px;
				height: 305px;
				.bg();
				background-size: 100% 274px;
				background-position: bottom center;
				background-image: url("../../assets/userinfo/c5.png");

				.close {
					right: 23px;
					top: -4px;
					background-image: url("../../assets/common/close.svg");
				}
				.text1 {
					margin-top: 82px;
					color: #bb8009;
					font-size: 20px;
					font-weight: 700;
					text-align: center;
				}
				.text2 {
					text-align: center;

					div {
						display: inline-block;
						padding: 0 17px;
						margin-top: 30px;
						text-align: center;
						color: #666666;
						font-size: 15px;
						.bg();
						background-image: url("../../assets/userinfo/c6.svg");
					}
				}
				.sign-reward-wrap {
					text-align: center;
					margin-top: 2px;
					.reward1-wrap,
					.reward2-wrap {
						display: inline-block;

						.reward-icon {
							width: 84px;
							height: 84px;
							.bg();
							background-image: url("../../assets/userinfo/c8.png");
						}

						.reward-text,
						.reward-text2 {
							font-size: 24px;
							color: #2360e5;
							font-weight: 700;
						}
						.reward-text {
							margin-top: -5px;
						}
						.reward-text2 {
							margin-top: -2px;
							font-size: 12px;
						}

						.growth-roll-wrap {
							margin-top: -30px;
							display: inline-block;
						}
					}
					.reward1-wrap {
						position: relative;
						.vip-reward {
							position: absolute;
							padding-left: 17px;
							bottom: 6px;
							right: -26px;
							color: #f0d1b5;
							font-size: 12px;
							font-weight: 700;
						}
						.vip-reward::before {
							position: absolute;
							left: 2px;
							bottom: 3px;
							content: "";
							width: 17px;
							height: 17px;
							.bg();
							background-image: url("../../assets/userinfo/c9.png");
						}
					}

					.reward2-wrap {
						margin-left: 48px;
						.reward-icon {
							background-image: url("../../assets/userinfo/c7.png");
						}
						.reward-text,
						.reward-text2 {
							color: #bb8009;
						}
					}
				}
			}
			.sign-success-content::before {
				content: "";
				top: 0;
				left: 50%;
				transform: translate(-50%, 0);
				position: absolute;
				width: 75px;
				height: 75px;
				.bg();
				background-image: url("../../assets/userinfo/c4.svg");
			}
		}
	}
	.sign-message-wrap::before {
		content: "";
		position: absolute;
		top: 52px;
		left: 218px;
		width: 178px;
		height: 44px;
		.bg();
		background-image: url("../../assets/userinfo/b2.svg");
	}
	.sign-message-wrap::after {
		content: "";
		position: absolute;
		top: 26px;
		left: 155px;
		width: 381px;
		height: 106px;
		.bg();
		background-image: url("../../assets/userinfo/b1.svg");
	}

	.bind-phone-wrap {
		position: relative;
		padding-top: 17px;
		text-align: center;
		font-size: 12px;

		.close {
			position: absolute;
			top: 17px;
			right: 24px;
			width: 20px;
			height: 20px;
			cursor: pointer;
		}

		.bind-phone-text1 {
			color: #1a1a1a;
			font-size: 17px;
			font-weight: bold;
		}
		.bind-phone-text2 {
			margin-top: 32px;
			margin-left: 41px;
			text-align: left;
			color: #999999;
		}

		.input-wrap {
			position: relative;
			margin: 0 auto;
			margin-top: 13px;
			overflow: hidden;
			border-radius: 41px;
			width: 287px;
			height: 41px;
			border: 1px solid #f0af2d;
			box-sizing: border-box;
			.phone,
			.code {
				padding-left: 20px;
				width: 100%;
				height: 100%;
				box-sizing: border-box;
				background-color: #ffffff;
				font-size: 12px;
				color: #666666;
			}

			input::-webkit-outer-spin-button,
			input::-webkit-inner-spin-button {
				-webkit-appearance: none;
			}
			input[type="number"] {
				-moz-appearance: textfield;
			}

			.code-btn {
				position: absolute;
				right: 0;
				width: 114px;
				line-height: 39px;
				height: 39px;
				background-color: #eaecef;
				font-size: 12px;
				text-align: center;
				color: #666666;
				box-sizing: border-box;
				cursor: pointer;
				box-sizing: border-box;
			}
			.countdown {
				padding-right: 20px;
				text-align: right;
			}
		}

		.bind-btn {
			margin: 0 auto;
			margin-top: 35px;
			width: 187px;
			height: 41px;
			line-height: 41px;
			border-radius: 102px;
			color: #ffffff;
			font-size: 14px;
			font-weight: bold;
			background-color: #f9c357;
			background-image: linear-gradient(to right, #f9c357, #f0af2d);
			cursor: pointer;
		}
	}
}
</style>
